namespace Areas.PunchList.Items {
    "use strict";

    let currentPunchListItem: any;


    export function onNewPunchListItemRow(e: any) {
        e.data.accountId = e.component.option("AccountId");
        currentPunchListItem = e.data;
        currentPunchListItem.punchListProfileId = e.component.option("PunchListProfileId");
    }

    export function updatePunchListItem() {
        const grid = $("#PunchListItemGrid").dxForm("instance");
        const newData: any = grid.option("gridData");
        const result: any = grid.validate();
        const keyId: any = grid.option("KeyId");

        if (result.isValid && keyId != null) {
            sendRequest(`/PunchList/Items/Put/${keyId}`, JSON.stringify(newData), "PUT");
        }
    }

    export function onEditingItemStart(e: any) {
        currentPunchListItem = e.data;
    }


    // select contact
    export function editContactTemplate(cellElement, cellInfo) {
        let displayName = !cellInfo.data.displayName ? "Select..." : cellInfo.data.displayName;;

        let htmlString = `<div class="dx-texteditor dx-lookup-empty dx-widget dx-textbox dx-dropdowneditor dx-lookup dx-lookup-popover-mode"><input type="hidden" value=""><div class="dx-lookup-field-wrapper"><div class="dx-lookup-field" tabindex="0" role="combobox" aria-expanded="false">${displayName}</div><div class="dx-lookup-arrow" id="contact-popup-button"></div></div></div>`;
        let html = $.parseHTML(htmlString);

        cellElement.on("click", selectContact);
        cellElement.append(html);
    }

    export function selectContact() {
        const dataGrid = $("#PunchListItemGrid").dxDataGrid("instance");
        const accountId = dataGrid.option("AccountId");
        const parameters = { accountId: accountId };
        const accountTeamContactLookupDialog =
            new Areas.Dialogs.AccountTeam.AccountTeamContactLookupDialog(
                dialogAccountTeamContactClosing, parameters);
    }

    function dialogAccountTeamContactClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataGrid = $("#PunchListItemGrid").dxDataGrid("instance");

        var rowIndex = getItemRowIndex(dataGrid);
        updateGridItemRow(dataGrid, rowIndex, data);
    }

    export function returnToListFromTab() {
        var linkInfo = "/PunchList/List/Active";
        location.href = linkInfo;

    }

    export function addGridButtons(e: any) {
        const grid: DevExpress.ui.dxDataGrid = e.component;

        let disabledButton = grid.option("IsEditable");

        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { id: "import" },
            text: "Import",
            hint: "Import",
            type: "default",
            icon: "add",
            disabled: disabledButton,
            //onClick: addCoverage()
        }, "before");

    }


    export function onPunchListItemInserted(e: any) {
        currentPunchListItem = null;
    }

    function getItemRowIndex(dataGrid: DevExpress.ui.dxDataGrid): number {
        let rowIndex = 0;

        if (currentPunchListItem === undefined || currentPunchListItem === null) {
            return rowIndex;
        } else if (currentPunchListItem.punchListItemId) {
            rowIndex = dataGrid.getRowIndexByKey(currentPunchListItem.punchListItemId);
        }

        return rowIndex;
    }

    function updateGridItemRow(dataGrid: DevExpress.ui.dxDataGrid, rowIndex: number, data: any) {

        dataGrid.cellValue(rowIndex, "itemAssignedToContactId", data.contactId);
        dataGrid.cellValue(rowIndex, "displayName", data.displayName);

        currentPunchListItem.itemAssignedToContactId = data.contactId;
        currentPunchListItem.displayName = data.displayName;

        dataGrid.repaintRows([rowIndex]);
    }

    export function goToActions(projectInfoId: number, sharePointLink: string) {
        return (e: any) => {
            if (e.value == 1) {
                goToSharePoint(sharePointLink);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                goToPIFPAF(projectInfoId);
                clearSelectBoxSelection(e);
                return;
            }
        }
    }

    function goToSharePoint(sharePointLink) {
        if (sharePointLink != null) {
            Areas.websiteSharePoint(sharePointLink);
        }
        return
    }

    function goToPIFPAF(projectInfoId) {
        let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + projectInfoId + "";
        window.open(linkInfo);
    }

}